module.exports = __webpack_public_path__ + "img/close.d1c327a7.svg";